import { isPlatformServer } from "@angular/common";
import { inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Subject } from "rxjs";
import { AuthService } from "./auth.service";
import { EnvService } from "@gea-waldviertler-website/shop-lib";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  platformId: Object
  socket?: WebSocket
  channel: Subject<any>

  authService: AuthService
  private envService = inject(EnvService)

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    @Inject(AuthService) authService: AuthService,
  ) {

    this.platformId = platformId
    this.channel = new Subject<any>()
    this.authService = authService

    if (isPlatformServer(this.platformId)) {
      return
    }

    this.createSocket()

    this.channel.subscribe(message => {
      if (message.event == 'auth') {
        if (message.data == 'ok') {
          console.debug('The socket authentication succeeded!')
        } else { // if (message.data == 'fail')
          // this.authService?.removeUser()
          // console.debug('The socket authentication failed or the session expired, so force logout!')
        }
      }
    })
  }

  private authenticate(authToken: string) {
    if (this.socket) {
      //console.debug('Authenticating socket...')

      if (this.socket.readyState === 0) // connecting
        this.socket.onopen = () => this.socket?.send('{ "event": "auth", "data": "Bearer ' + authToken + '" }')

      if (this.socket.readyState === 1) // open
        this.socket?.send('{ "event": "auth", "data": "Bearer ' + authToken + '" }')
    }
  }

  private createSocket(): void {

    this.socket = new WebSocket(this.envService.config.wsURL + '/ws/notify/');
    this.socket.addEventListener('message', (event) => {
      this.channel.next(JSON.parse(event.data))
    });

    this.socket.addEventListener('error', error => {
      //console.debug('Websocket reconnecting on error:', error)
      this.createSocket()
    });

    const user = this.authService.user()
    if (user) {
      this.authenticate(user.authToken)
    }
  }

  public getChannel(): Subject<any> {
    return this.channel
  }
}
